import { createMultiStyleConfigHelpers as l, cssVar as o } from "@chakra-ui/styled-system";
const { defineMultiStyleConfig: c, definePartsStyle: a } = l([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), e = o("stepper-indicator-size"), t = o("stepper-icon-size"), i = o("stepper-title-font-size"), s = o("stepper-description-font-size"), r = o("stepper-accent-color"), p = a(({ colorScheme: n }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [r.variable]: "colors.".concat(n, ".500"),
    _dark: {
      [r.variable]: "colors.".concat(n, ".200")
    }
  },
  title: {
    fontSize: i.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: s.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: i.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: t.reference,
    height: t.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: e.reference,
    height: e.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: r.reference
    },
    "&[data-status=complete]": {
      bg: r.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: r.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: "calc(100% - ".concat(e.reference, " - 8px)"),
      top: "calc(".concat(e.reference, " + 4px)"),
      insetStart: "calc(".concat(e.reference, " / 2 - 1px)")
    }
  }
})), d = c({
  baseStyle: p,
  sizes: {
    xs: a({
      stepper: {
        [e.variable]: "sizes.4",
        [t.variable]: "sizes.3",
        [i.variable]: "fontSizes.xs",
        [s.variable]: "fontSizes.xs"
      }
    }),
    sm: a({
      stepper: {
        [e.variable]: "sizes.6",
        [t.variable]: "sizes.4",
        [i.variable]: "fontSizes.sm",
        [s.variable]: "fontSizes.xs"
      }
    }),
    md: a({
      stepper: {
        [e.variable]: "sizes.8",
        [t.variable]: "sizes.5",
        [i.variable]: "fontSizes.md",
        [s.variable]: "fontSizes.sm"
      }
    }),
    lg: a({
      stepper: {
        [e.variable]: "sizes.10",
        [t.variable]: "sizes.6",
        [i.variable]: "fontSizes.lg",
        [s.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "primary"
  }
});
export {
  d as stepperTheme
};
